import { Component, OnInit } from '@angular/core';
import { ApiConnectionService } from '../services/api-connection.service';
import { TranslateServiceService } from '../services/translate-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  collectorList: any;
  mainImage: string;
  // Translate service
  text: any = {};
  notCurrentLanguage = "";
  currentLanguage: string = 'es';
  // Global loader
  arePageReady: boolean = false;
  // Config race
  goalBarBg: string;

  constructor(
    private apiService: ApiConnectionService,
    private translateService: TranslateServiceService,
    private router: Router
  ){
    let _ = this;
    _.getCurrentLanguage();
  }

  ngOnInit() {
    let _ = this;
    window.scrollTo(0, 0)
  }

  ngAfterViewInit(){
    let _ = this;
    _.getCollectors();
    _.getMainImage();
  }

  getCurrentLanguage() {
    let _ = this;
    let isEN = _.translateService.getCurrentLanguage() === 'EN';
    _.translateService.getJSON("assets/translations/home.translations.json")
      .subscribe((res) => {
        if(isEN){
          _.text = res.english;
          _.notCurrentLanguage = 'ES';
          _.currentLanguage = 'en'
        }else{
          _.text = res.spanish;
          _.notCurrentLanguage = 'EN';
          _.currentLanguage = 'es';
        }
      });
  }

  getMerchant(){
    let _ = this;
    let merchant: any = location.href.split('/');

    return merchant[3];
  }

  getRaceName(){
    let _ = this;
    let raceName: any = _.router.url.split('/');
    let hasSomeQuery = raceName[2].includes('?');

    if(hasSomeQuery) {
      let raceWithoutStatus = raceName[2].split('?')[0];
      let queryMsg = raceName[2].split('?')[1];
      queryMsg = queryMsg.split('&')[1];
      queryMsg = queryMsg.split('=')[1];
      queryMsg = decodeURI(queryMsg).split(' ').join('_');

      let queryStatus = raceName[2].split('?')[1];
      queryStatus = queryStatus.split('=')[1];
      queryStatus = queryStatus.split('&')[0];
      _.router.navigate([`/${_.getMerchant()}/${raceWithoutStatus}/status/${queryStatus}/msg/${queryMsg}`]);
    }

    return raceName[2];
  }

  getCollectors(){
    let _ = this;
    let conditions = {
      "conditions":{
        "race_url": _.getRaceName()
      },
      "merchant": _.getMerchant(),
    }
    _.apiService.getTopDonors(conditions).subscribe(data => {
      _.collectorList = data['results'];
      setTimeout(() => {
        _.arePageReady = true;
      }, 1000)
    })
  }

  generateUrl(name, type, urlTeam){
    let typeDonor = '/'+ urlTeam +'/' + name
    if(type == 'team'){
      typeDonor = '/' + name;
    }

    return typeDonor;
  }

  getMainImage(){
    let _ = this;
    let conditions = {
      "conditions": {
        "race_url": _.getRaceName(),
        "active": true,
      },
      "merchant": _.getMerchant(),
    }
    _.apiService.getQuantities(conditions).subscribe(data => {
      _.goalBarBg = data['results'][0].design.color.secundary;
      if(_.translateService.getCurrentLanguage(data['results'][0].design.languages.default) == 'ES'){
        _.mainImage = data['results'][0].design.banner.es[0];
        return;
      }
      _.mainImage = data['results'][0].design.banner.en[0];
    })
  }
}
